import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiSearch, apiFetch } from '../../modules/utility';


const apiBase = 'driverReport';
const word = 'report';
const idsField = 'driverReportIds';
const onSuccessRedirectTo = `/driver/pickReport`;

const search = (p = {}) => {
	const {callback = _.noop} = p;
	return dispatch => {
		apiSearch({
			base : apiBase,
			dispatch,
			callback,
		});
	};
};

const get = ({params = {}, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate : idsField,
			params,
			dispatch,
			successMessage : `Your ${word} was created successfully. 
				Click continue to return to the ${word} page.`,
			onSuccessRedirectTo,
			callback,
		});
	};
};

const update = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			successMessage : `The ${word} updated successfully. 
				Click continue to return to the ${word} page.)`,
			onSuccessRedirectTo,
			callback,
		});
	};
};

const mapStateToProps = (state, ownProps) => {
	let driverReport;
	let driverReportId;

	/** @namespace ownProps.driverReportId */
	if (ownProps.driverReport) {
		driverReport = ownProps.driverReport;
	} else {
		driverReportId = (ownProps.driverReportId)
			? ownProps.driverReportId
			: _.get(ownProps, ['match', 'params', 'driverReportId']);
		driverReport = _.get(state.maps, ['driverReport', driverReportId]);
	}

	/** @namespace state.lists.driverReportIds */
	let driverReports = [];
	if (state.lists.driverReportIds) {
		driverReports = _.map(state.lists.driverReportIds, id => state.maps.driverReport[id]);
	}

	return {
		driverReport,
		driverReports,
		userMap : state.maps.user,
		resourceMap : state.maps.resource,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	getDriverReport : get,
	addDriverReport : add,
	updateDriverReport : update,
	searchDriverReports : search,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
